'use client';

import React from 'react';
import { Hand, Users } from 'lucide-react';
import { useHandRaiseQueue } from './HandRaiseQueueContext';
import { Badge } from '@/components/ui/badge';

interface HandRaiseQueueButtonProps {
  onClick: () => void;
  isActive: boolean;
  inline?: boolean;
}

export function HandRaiseQueueButton({
  onClick,
  isActive,
  inline = false,
}: HandRaiseQueueButtonProps) {
  const { getQueueCount } = useHandRaiseQueue();
  const queueCount = getQueueCount();

  if (queueCount === 0) return null;

  return (
    <button
      type="button"
      onClick={onClick}
      data-hand-raise-queue-button="true"
      className={`lk-button lk-hand-raise-queue-toggle ${inline ? 'lk-hand-raise-queue-toggle--inline' : ''} ${isActive ? 'is-active' : ''}`}
      title={`Ver fila de mãos levantadas (${queueCount})`}
    >
      <div className="relative">
        <Users size={inline ? 20 : 16} />
        {queueCount > 0 && (
          <Badge
            className="absolute -top-2 -right-2 min-w-[18px] h-[18px] text-xs bg-yellow-400 text-black border-0 flex items-center justify-center p-0"
            style={{
              fontSize: '10px',
              lineHeight: '1',
            }}
          >
            {queueCount > 99 ? '99+' : queueCount}
          </Badge>
        )}
      </div>
      {!inline && <span>Fila ({queueCount})</span>}
    </button>
  );
}
